/**
 * Product card image carousel — uses Flickity (already loaded by the theme).
 * Lazy-init per card via IntersectionObserver.
 */
(function () {
  if (typeof window === 'undefined') return;
  var INIT = 'cardFlickityInit';

  function init(el) {
    if (el.dataset[INIT] === '1') return;
    if (typeof window.Flickity === 'undefined') return;
    el.dataset[INIT] = '1';

    // Find product URL via the sibling .grid-product__link so a static
    // (non-drag) click on a slide still navigates to the product page.
    var productUrl = '';
    var card = el.closest('.grid-product');
    if (card) {
      var anchor = card.querySelector('.grid-product__link');
      if (anchor && anchor.getAttribute('href')) productUrl = anchor.getAttribute('href');
    }

    try {
      var fky = new window.Flickity(el, {
        cellAlign: 'left',
        contain: true,
        wrapAround: false,
        pageDots: true,
        prevNextButtons: false,
        groupCells: false,
        draggable: true,
        freeScroll: false,
        dragThreshold: 5,
        selectedAttraction: 0.2,
        friction: 0.8,
        percentPosition: true,
        setGallerySize: true,
        resize: true,
        accessibility: true,
        imagesLoaded: false,
        lazyLoad: false,
        on: {
          ready: function () {
            el.classList.add('card-carousel--ready');
          }
        }
      });

      if (productUrl) {
        fky.on('staticClick', function (event, pointer, cellElement) {
          // Don't hijack clicks on the pagination dots themselves
          if (event && event.target && event.target.closest && event.target.closest('.flickity-page-dots')) return;
          window.location.href = productUrl;
        });
      }
    } catch (e) {
      el.dataset[INIT] = '';
    }
  }

  var observer = null;
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          init(entries[i].target);
          observer.unobserve(entries[i].target);
        }
      }
    }, { rootMargin: '300px 0px' });
  }

  function scan(root) {
    var nodes = (root || document).querySelectorAll('[data-card-carousel]');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.dataset[INIT] === '1') continue;
      if (observer) observer.observe(n);
      else init(n);
    }
  }

  function whenReady(cb) {
    if (typeof window.Flickity !== 'undefined') { cb(); return; }
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (typeof window.Flickity !== 'undefined') { clearInterval(iv); cb(); }
      else if (tries > 150) { clearInterval(iv); }
    }, 100);
  }

  function domReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  domReady(function () {
    whenReady(function () {
      scan(document);
      if ('MutationObserver' in window) {
        var mo = new MutationObserver(function (mutations) {
          for (var i = 0; i < mutations.length; i++) {
            var added = mutations[i].addedNodes;
            for (var j = 0; j < added.length; j++) {
              var node = added[j];
              if (node.nodeType !== 1) continue;
              if (node.matches && node.matches('[data-card-carousel]')) {
                if (observer) observer.observe(node);
                else init(node);
              } else if (node.querySelectorAll) {
                scan(node);
              }
            }
          }
        });
        mo.observe(document.body, { childList: true, subtree: true });
      }
    });
  });
})();
